import { ComponentChild } from 'preact'
import classnames from 'classnames'
import LazyImage from '@insided/shared/uikit/LazyImage'
import { CardNavigation, getCardComponent } from './getCardComponent'

export interface CardProps {
  idx: number
  key?: number
  title: string
  customClass?: string
  metadata?: ComponentChild
  displayInfoHorizontal?: boolean
  isControl?: boolean
  navigation?: CardNavigation
  imageSrc?: string
  imageType?: 'icon' | 'image'
  position?: 'vertical' | 'horizontal'
  onClick?: () => void
  size?: 'S' | 'M' | 'L' | 'full-width'
  disabled?: boolean
}

const Card = (props: CardProps) => {
  const {
    customClass,
    navigation,
    title,
    imageSrc,
    imageType = 'image',
    metadata,
    idx,
    position = 'vertical',
    size = 'S',
    onClick,
    isControl = false,
    displayInfoHorizontal = false,
    disabled = false
  } = props
  const Component = getCardComponent(props.navigation)

  return (
    <article
      className={classnames(
        'o-card',
        `o-card-${position}`,
        `o-card__content-size-${size}`,
        customClass,
        {
          'o-card--app-control': isControl,
          'm-card-disabled': disabled
        }
      )}
    >
      <Component
        href={navigation?.url}
        className={classnames(`m-card-${position}`, {
          'm-card_url': !!navigation
        })}
        target={navigation?.target}
        onClick={onClick}
      >
        {imageSrc && (
          <figure className={classnames('a-card-visual', `a-card-${imageType}`)}>
            <LazyImage
              type='background'
              src={imageSrc}
              alt={`Community category image ${idx + 1}`}
            />
          </figure>
        )}
        <div
          className={classnames('m-card_info', {
            'm-card_info--horizontal': displayInfoHorizontal
          })}
        >
          <header>
            <h5 className='a-card_info__title a-card-widget-title'>{title}</h5>
          </header>
          {metadata ? <p className='text--meta a-card-info__metadata'>{metadata}</p> : null}
        </div>
      </Component>
    </article>
  )
}

export default Card
